import { useEffect, useState } from "react";
import { Flag } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { shortDate } from "@/lib/format";

export function ChatReportsPanel() {
  const [reports, setReports] = useState([]);
  const load = () => api.get("/admin/chat/reports").then((r) => setReports(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const resolve = async (id) => { try { await api.post(`/admin/chat/reports/${id}/resolve`); toast.success("Denúncia resolvida."); load(); } catch (e) { toast.error(errorMessage(e)); } };
  const suspend = async (uid) => { try { await api.post(`/admin/chat/users/${uid}/suspend`, { suspended: true }); toast.success("Chat suspenso para o usuário."); } catch (e) { toast.error(errorMessage(e)); } };
  return (
    <div className="ga-card p-4" data-testid="admin-chat-reports">
      <div className="flex items-center gap-2 text-sm font-semibold"><Flag size={16} /> Denúncias do Chat ({reports.length})</div>
      <p className="ga-muted mt-1 text-xs">Só aparecem as mensagens que o denunciante escolheu compartilhar. O conteúdo das conversas é cifrado de ponta a ponta e não pode ser lido pela administração.</p>
      <ul className="mt-2 space-y-2">{reports.map((r) => (
        <li key={r.id} className="rounded-2xl p-3 text-xs" style={{ background: "var(--ga-surface)" }} data-testid={`admin-chat-report-${r.id}`}>
          <div><b>@{r.reporter_username}</b> denunciou <b>@{r.reported_username}</b> · {shortDate(r.created_at)}</div>
          <div className="mt-1">{r.reason}</div>
          {r.messages.length > 0 && <ul className="mt-2 space-y-1 border-l-2 pl-2" style={{ borderColor: "var(--ga-border)" }}>{r.messages.map((m, i) => <li key={i}><b>{m.from_username}:</b> {m.text}</li>)}</ul>}
          <div className="mt-2 flex gap-2"><button onClick={() => resolve(r.id)} className="ga-btn-ghost px-3 py-1" data-testid={`admin-chat-resolve-${r.id}`}>Resolver</button><button onClick={() => suspend(r.reported_user_id)} className="ga-btn-ghost px-3 py-1 text-red-500" data-testid={`admin-chat-suspend-${r.id}`}>Suspender Chat</button></div>
        </li>))}</ul>
      {!reports.length && <p className="ga-muted mt-2 text-xs">Nenhuma denúncia aberta.</p>}
    </div>
  );
}
